// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  py, mt, m, mb, my
} from 'styled-components-spacing';
import theme from '@theme';

const { colors } = theme;

export const StyledWrapper = styled(Grid.Unit)`
  ${m(3.5)}
  ${breakpoint('mobile', 'tablet')`
   ${m(2.5)}
 `}
`;

export const StyledListItem = styled(Grid)`
  max-width: 490px;
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 ${colors.mediumGray};
  margin: 0 auto;
  overflow: hidden;
`;

export const StyledTextContainer = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${mt(3)}
  ${mb(3)}
  cursor: default;
  align-items: center;
  align-self: flex-end;
  width: 100%;
  ${breakpoint('mobile', 'tablet')`
   ${mb(2)}
  `}
  min-width: 0;
  & > p {
    width: 100%;
    position: relative;
    text-align: start;
    word-break: break-word;
    ${breakpoint('desktop')`
      text-align: center;
    `}
  }
`;

export const StyledImageContainer = styled.div`
  width: calc(100% - 15px);
  margin: 0 auto;
  margin-top: 7.5px;
  ${breakpoint('mobile', 'tablet')`
  width: calc(100% - 10px);
  margin-top: 5px;
  `}
`;

export const StyledPositionText = styled.div`
 height: 45px;
 width: 85%;
 margin: 0 auto;
 margin-bottom: 5px;
 display: flex;
 justify-content: center;
 align-items: center;
 text-align: center;
 font-size: 16px;
 font-weight: 600;
 line-height: 22px;
 ${breakpoint('mobile', 'tablet')`
  font-size: 12px;
  line-height: 14.63px;
  letter-spacing: 0.5px;
  height: 30px;
  width: 90%;
`}
  color: ${colors.darkBlue};
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow-y: hidden;
  overflow-x: hidden;
`;

export const StyledDepartmentText = styled.div`
  width: 85%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1.57;
  color: ${colors.mediumGray};
  height: 50px;
  font-weight: 500;
  overflow: hidden;
  ${breakpoint('mobile', 'tablet')`
  font-size: 10px;
  width: 90%;
  height: 33px;
  margin-bottom: 0px;
  line-height: 14.19px;
`}
`;

export const StyledStayingDays = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.5px;
  letter-spacing: 0.1px;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 85%;
  height: 50px;
  color: ${colors.translucentDarkBlue};
  ${breakpoint('mobile', 'tablet')`
  font-size: 10px;
  height: 35px;
  width: 90%;
  line-height: 14.9px;
`}
`;
export const StyledSucessrate = styled(StyledStayingDays)`
  height: 1em;
  ${my(1)}
  ${breakpoint('mobile', 'tablet')`
  display: none;
  `}
`;
export const StyleText = styled.span`
  color: ${colors.darkGreen};
  font-weight: 700;
  letter-spacing: 0.3px;
`;
export const StyledCostWrapper = styled.div`
  font-size: 15px;
  line-height: 25px;
  font-weight: 500;
  width: 85%;
  margin: 0 auto;
  height: 50px;
  text-align: center;
  color: ${colors.darkBlue};
  ${breakpoint('mobile', 'tablet')`
  font-size: 10px;
  height: 35px;
  width: 90%;
  line-height: 15px;
`}
`;
export const StyledHospitalText = styled.p`
  ${py(2.5)}
  font-size: 14px;
  color: ${colors.darkBlue};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  width: calc(100% - 20px);
  height: 45px;
  margin: 0 auto;
  margin-bottom: 10px;
  color: ${props => (props.startDate ? `${colors.aquaMarine}` : `${colors.darkBlue}`)};
  transition: 0.3s;
  :hover {
    color: ${props => props.Treatment && `${colors.blueNavi}`};
  }
  ${props =>
    props.Image
    && `width: 100%;
    height: 100%;
  `}
  ${breakpoint('mobile', 'tablet')`
    height: 27px;
    width: calc(100% - 30px);
  `}
`;
export const StyledStartDateText = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  align-self: flex-end;
  width: 100%;
  font-weight: 700;
  color: ${colors.aquaMarine};
  background-color: transparent;
  box-sizing: border-box;
  border: solid 2px ${colors.translucentAquaMarine};
  transition: 0.3s;
  :hover {
    background-color: ${colors.aquaMarine};
    color: ${colors.white};
    border: none;
  }
  & > svg {
    display: none;
  }
  letter-spacing: 0.5px;
  border-radius: 10px;
  height: 100%;
  ${breakpoint('mobile', 'tablet')`
     font-size: 9px;
     border-radius: 10px;
  `}
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 0.75em;
  height: 1em;
  line-height: 11px;
`;
